export const productCategoryAddLanguage = {
    en: {
        GroupID: 'Group ID',
        GroupName: 'Group Name',
        Submit: 'Submit',
        Cancel: 'Cancel',
        'Failed to submit category. Please try again later.': 'Failed to submit category. Please try again later.',
        ProductCategory: 'Product Category',
        'Add Category': 'Add Category',
        Action: 'Action',
        'Are you sure you want to delete this group?': 'Are you sure you want to delete this group?',
        'Group deleted successfully': 'Group deleted successfully',
        'Failed to delete group': 'Failed to delete group',
        'Failed to delete group. Please try again later.': 'Failed to delete group. Please try again later.',
        AddEditCategory: 'Add/Edit Category',
    },
    th: {
        GroupID: 'รหัสกลุ่ม',
        GroupName: 'ชื่อกลุ่ม',
        Submit: 'บันทึก',
        Cancel: 'ยกเลิก',
        'Failed to submit category. Please try again later.': 'บันทึกหมวดหมู่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        ProductCategory: 'หมวดหมู่สินค้า',
        'Add Category': 'เพิ่มหมวดหมู่',
        Action: 'การกระทำ',
        'Are you sure you want to delete this group?': 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้?',
        'Group deleted successfully': 'ลบกลุ่มสำเร็จ',
        'Failed to delete group': 'ลบกลุ่มไม่สำเร็จ',
        'Failed to delete group. Please try again later.': 'ลบกลุ่มไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        AddEditCategory: 'เพิ่ม/แก้ไขหมวดหมู่',
    },
    cn: {
        GroupID: '组ID',
        GroupName: '组名',
        Submit: '提交',
        Cancel: '取消',
        'Failed to submit category. Please try again later.': '提交类别失败，请稍后再试。',
        ProductCategory: '产品类别',
        'Add Category': '添加类别',
        Action: '操作',
        'Are you sure you want to delete this group?': '您确定要删除此组吗？',
        'Group deleted successfully': '组删除成功',
        'Failed to delete group': '删除组失败',
        'Failed to delete group. Please try again later.': '删除组失败，请稍后再试。',
        AddEditCategory: '添加/编辑类别',
    },
    jp: {
        GroupID: 'グループID',
        GroupName: 'グループ名',
        Submit: '送信',
        Cancel: 'キャンセル',
        'Failed to submit category. Please try again later.': 'カテゴリの送信に失敗しました。後でもう一度お試しください。',
        ProductCategory: '商品カテゴリ',
        'Add Category': 'カテゴリ追加',
        Action: '操作',
        'Are you sure you want to delete this group?': 'このグループを削除してもよろしいですか？',
        'Group deleted successfully': 'グループが正常に削除されました',
        'Failed to delete group': 'グループの削除に失敗しました',
        'Failed to delete group. Please try again later.': 'グループの削除に失敗しました。後でもう一度お試しください。',
        AddEditCategory: 'カテゴリの追加/編集',
    },
    kr: {
        GroupID: '그룹 ID',
        GroupName: '그룹 이름',
        Submit: '제출',
        Cancel: '취소',
        'Failed to submit category. Please try again later.': '카테고리 제출에 실패했습니다. 나중에 다시 시도해 주세요.',
        ProductCategory: '상품 카테고리',
        'Add Category': '카테고리 추가',
        Action: '동작',
        'Are you sure you want to delete this group?': '이 그룹을 삭제하시겠습니까?',
        'Group deleted successfully': '그룹이 성공적으로 삭제되었습니다',
        'Failed to delete group': '그룹 삭제 실패',
        'Failed to delete group. Please try again later.': '그룹 삭제에 실패했습니다. 나중에 다시 시도해 주세요.',
        AddEditCategory: '카테고리 추가/편집',
    }
}